import { Injectable, OnDestroy } from '@angular/core';
import { SignalRService } from './signalr.sevice';
import { AuthService } from '../../auth/auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter, takeUntil, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SignalRConnectionManagerService implements OnDestroy {
  private readonly destroy$ = new Subject<void>();
  private currentRoute = '';

  constructor(
    private readonly signalRService: SignalRService,
    private readonly authService: AuthService,
    private readonly router: Router
  ) {}

  initialize(): void {
    this.initializeConnectionManagement();
  }

  private initializeConnectionManagement(): void {
    this.authService.LoginStatus$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(isAuthenticated => {
      if (!isAuthenticated) {
        // User logged out, stop SignalR connection
        this.signalRService.forceStopConnection();
      }
    });

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntil(this.destroy$)
    ).subscribe((event: NavigationEnd) => {
      const newRoute = event.url;
      
      // If navigating away from transaction page, stop SignalR connection
      if (this.currentRoute.includes('/transaction') && !newRoute.includes('/transaction')) {
        this.signalRService.forceStopConnection();
      }
      
      this.currentRoute = newRoute;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
